import firebaseCl from './firebase.js';
import 'firebase/firestore';

let firebase = firebaseCl();
firebase.firestore().enablePersistence();
export default firebase.firestore();



// WEBPACK FOOTER //
// ./src/database.js